
import {
	CheckCircleOutlined,
	CheckCircleSolid,
	ExclamationCircleOutlined,
	ExclamationCircleSolid,
	ExclamationOutlined,
	CheckOutlined,
} from '@/assets/svgs/DesignSystem/status';
import {
	MaximizeOutlined,
	MinimizeOutlined,
	ChevronDownOutlined
} from '@/assets/svgs/DesignSystem/navigation';
import { IconStyle } from '@/componentsDS/Icon/Icon.type';
import { NotificationSettingsOutlined, NotificationSettingsSolid } from '@/assets/svgs/DesignSystem/system';
import { XMarkOutlined, MinusOutlined } from '@/assets/svgs/DesignSystem/general-tool';

const iconMap = {
	'check-circle': {
		[IconStyle.OUTLINED]: CheckCircleOutlined,
		[IconStyle.SOLID]: CheckCircleSolid
	},
	'exclamation-circle': {
		[IconStyle.OUTLINED]: ExclamationCircleOutlined,
		[IconStyle.SOLID]: ExclamationCircleSolid
	},
	'maximize': {
		[IconStyle.OUTLINED]: MaximizeOutlined,
		[IconStyle.SOLID]: MaximizeOutlined
	},
	'minimize': {
		[IconStyle.OUTLINED]: MinimizeOutlined,
		[IconStyle.SOLID]: MinimizeOutlined
	},
	exclamation: {
		[IconStyle.OUTLINED]: ExclamationOutlined,
		[IconStyle.SOLID]: ExclamationOutlined
	},
	'chevron-down': {
		[IconStyle.OUTLINED]: ChevronDownOutlined,
		[IconStyle.SOLID]: ChevronDownOutlined
	},
	'notification-settings': {
		[IconStyle.OUTLINED]: NotificationSettingsOutlined,
		[IconStyle.SOLID]: NotificationSettingsSolid
	},
	'x-mark': {
		[IconStyle.OUTLINED]: XMarkOutlined,
		[IconStyle.SOLID]: XMarkOutlined
	},
	minus: {
		outlined: MinusOutlined,
		solid: MinusOutlined
	},
	check: {
		outlined: CheckOutlined,
		solid: CheckOutlined
	},
};

export default iconMap;
